import { Expose, Type } from 'class-transformer';
import { SortBy } from './data-source';

export class ViewState {
  @Expose({ name: 'field' })
  @Type(() => ViewStateField)
  fields: ViewStateField[];
  @Type(() => ViewStateSort)
  sort: ViewStateSort;
  @Expose({ name: 'group' })
  @Type(() => ViewStateGroup)
  groups?: ViewStateGroup[];
  additional?: Record<string, any>;

  constructor(fields: ViewStateField[], sort: ViewStateSort, groups?: ViewStateGroup[], additional?: Record<string, any>) {
    this.fields = fields;
    this.sort = sort;
    this.groups = groups;
    this.additional = additional;
  }
}

export class ViewStateField {
  name: string;
  visible?: boolean;
  autoFitWidth?: boolean;
  width?: number;
  frozen?: boolean;
  printable?: boolean;

  constructor(name: string) {
    this.name = name;
  }
}

export class ViewStateSort {
  fieldName: string;
  @Expose({ name: 'sortDir' })
  sortDirection: 'ascending' | 'descending';
  @Type(() => ViewStateField)
  sortSpecifiers: { property: string; direction: 'ascending' | 'descending' }[];

  constructor(sorts: SortBy[]) {
    if (sorts?.length > 0) {
      this.fieldName = sorts[0].property;
      this.sortDirection = sorts[0].direction === 'asc' ? 'ascending' : 'descending';
      this.sortSpecifiers = sorts.map(s => ({ property: s.property, direction: s.direction === 'asc' ? 'ascending' : 'descending' }));
    }
  }

}

export class ViewStateGroup {
  fieldName: string;
  groupingMode?: string;
  groupGranularity?: string;
  groupPrecision?: string;

  constructor(fieldName: string) {
    this.fieldName = fieldName;
  }
}

